<script lang="ts">
	import type { Snippet } from 'svelte'
	import type { BreadcrumbItem } from '@repo/commons/models'

	interface Props {
		breadcrumbs: BreadcrumbItem[]
		rightSnippet?: Snippet
	}

	const { breadcrumbs, rightSnippet }: Props = $props()
</script>

{#if breadcrumbs.length > 0 || rightSnippet}
	<nav aria-label="Breadcrumb" class="breadcrumbs-wrapper">
		<div class="flex items-center gap-2">
			{#each breadcrumbs as crumb, i}
				{#if i > 0}
					<span class="separator" aria-hidden="true">/</span>
				{/if}
				{#if crumb.href}
					<a href={crumb.href} class="crumb">{crumb.label}</a>
				{:else}
					<span class="crumb current" aria-current="page">{crumb.label}</span>
				{/if}
			{/each}
		</div>
		{#if rightSnippet}
			{@render rightSnippet()}
		{/if}
	</nav>
{/if}

<style lang="postcss">
	.breadcrumbs-wrapper {
		@apply flex items-start justify-between min-h-[88px] px-8 py-5;
	}

	.crumb {
		@apply text-sm text-[#001D33B2];
	}

	a.crumb {
		@apply underline underline-offset-2 transition-colors;
	}

	a.crumb:hover {
		@apply text-[#001D33];
	}

	.crumb.current {
		@apply text-[#001D33B2];
	}

	.separator {
		@apply text-sm text-[#002C4D80] select-none;
	}
</style>
